import {
  GET_TRAINING_TYPES,
  GET_TRAINING_TYPES_FAIL,
  GET_TRAINING_TYPES_SUCCESS,
  ADD_NEW_TRAINING_TYPE,
  ADD_TRAINING_TYPE_SUCCESS,
  ADD_TRAINING_TYPE_FAIL,
  UPDATE_TRAINING_TYPE,
  UPDATE_TRAINING_TYPE_SUCCESS,
  UPDATE_TRAINING_TYPE_FAIL,
  DELETE_TRAINING_TYPE,
  DELETE_TRAINING_TYPE_SUCCESS,
  DELETE_TRAINING_TYPE_FAIL,
  
} from "./actionTypes";

export const getTrainingTypes = () => ({
  type: GET_TRAINING_TYPES,
})

export const getTrainingTypesSuccess = (trainingTypes) => ({
  type: GET_TRAINING_TYPES_SUCCESS,
  payload: trainingTypes,
})

export const getTrainingTypesFail = error => ({
  type: GET_TRAINING_TYPES_FAIL,
  payload: error,
})

export const addNewTrainingType = (trainingType) => ({
  type: ADD_NEW_TRAINING_TYPE,
  payload: trainingType,
})

export const addTrainingTypeSuccess = (trainingType) => ({
  type: ADD_TRAINING_TYPE_SUCCESS,
  payload: trainingType,
})

export const addTrainingTypeFail = error => ({
  type: ADD_TRAINING_TYPE_FAIL,
  payload: error,
})

export const updateTrainingType = (trainingType) => ({
  type: UPDATE_TRAINING_TYPE,
  payload: trainingType,
})

export const updateTrainingTypeSuccess = (trainingType) => ({
  type: UPDATE_TRAINING_TYPE_SUCCESS,
  payload: trainingType,
})

export const updateTrainingTypeFail = error => ({
  type: UPDATE_TRAINING_TYPE_FAIL,
  payload: error,
})

export const deleteTrainingType = (trainingType) => ({
  type: DELETE_TRAINING_TYPE,
  payload: trainingType,
})

export const deleteTrainingTypeSuccess = (trainingType) => ({
  type: DELETE_TRAINING_TYPE_SUCCESS,
  payload: trainingType,
})

export const deleteTrainingTypeFail = error => ({
  type: DELETE_TRAINING_TYPE_FAIL,
  payload: error,
})

